var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNavbarHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0376 12.4821L25.036 12.4805L15.5178 2.96273C15.1121 2.55684 14.5727 2.33325 13.999 2.33325C13.4252 2.33325 12.8858 2.55667 12.4799 2.96255L2.96674 12.4755C2.96354 12.4787 2.96034 12.4821 2.95713 12.4853C2.124 13.3233 2.12543 14.6828 2.96123 15.5186C3.34308 15.9006 4.66769 16.1219 5.20691 16.1451C5.22881 16.1472 5.25089 16.1483 5.27314 16.1483H5.6525V23.1528C5.6525 24.5388 6.78025 25.6666 8.16666 25.6666H11.0702C11.4476 25.6666 11.7538 25.3606 11.7538 24.983V19.4915C11.7538 18.859 12.2682 18.3445 12.9007 18.3445H15.0971C15.7297 18.3445 16.2441 18.859 16.2441 19.4915V24.983C16.2441 25.3606 16.5501 25.6666 16.9277 25.6666H19.8333C21.2197 25.6666 22.3475 24.5388 22.3475 23.1528V16.1483H22.6993C23.2728 16.1483 24.6304 15.9248 25.0365 15.519C25.8732 14.6817 25.8735 13.3199 25.0376 12.4821Z",
    fill: "url(#paint0_linear_641_4960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_641_4960",
    x1: 2.33333,
    y1: 12.2499,
    x2: 25.6643,
    y2: 12.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavbarHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/navbarHome.fae366c8.svg";
export { ForwardRef as ReactComponent };